import PropTypes from "prop-types"
import { memo, useMemo } from "react"
import { useRemarkSync } from "react-remark"
import { Link } from "react-router-dom"

import Button from "components/ui/button"
import { cn } from "styles/utils"

const getComponents = (defaultClassName, classNames, triggerPopup) => ({
  a: ({ href, ...props }) => (
    <Button
      asChild
      className={cn(defaultClassName, classNames?.anchorClassName)}
      text
      underline
    >
      <Link data-lc="countdown-banner" to={href} {...props} />
    </Button>
  ),
  p: ({ ...props }) => (
    <p
      className={cn(
        "inline whitespace-pre-line",
        defaultClassName,
        classNames?.paragraphClassName
      )}
      {...props}
    />
  ),
  ...(triggerPopup && {
    code: (props) => (
      <Button
        className={cn(defaultClassName, classNames?.anchorClassName)}
        onClick={() => {
          triggerPopup()
        }}
        text
        underline
        {...props}
      />
    ),
  }),
})

const MicroBannerMarkdown = ({
  children,
  classNames,
  defaultClassName,
  triggerPopup,
}) => {
  const components = useMemo(
    () => getComponents(defaultClassName, classNames, triggerPopup),
    [defaultClassName, classNames, triggerPopup]
  )
  const markdownContent = useRemarkSync(children, {
    rehypeReactOptions: { components },
    suppressHydrationWarning: true,
  })

  return markdownContent
}

MicroBannerMarkdown.propTypes = {
  children: PropTypes.string,
  classNames: PropTypes.object,
  defaultClassName: PropTypes.string,
  triggerPopup: PropTypes.func,
}

export default memo(MicroBannerMarkdown)
